import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Generic Types — Example Typer Definition",
description: "Learn how to define a typer for generic types and units of measurement in Freon. Explore infertype, equalsto, and conformsto rules and how type concepts connect to AST nodes.",
tags: [ "Freon", "typer", "generic types", "measurement units", "infertype", "equalsto", "conformsto", "TT_GenericType", "TT_MeasurementType", "GenericType", "UnitOfMeasurement", "type system", "example"] ,
modifiedTime: "2025-11-07T17:20:18.642Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};